import { render, staticRenderFns } from "./EnergyRatingSection.vue?vue&type=template&id=06a1fad8"
import script from "./EnergyRatingSection.vue?vue&type=script&lang=ts"
export * from "./EnergyRatingSection.vue?vue&type=script&lang=ts"
import style0 from "./EnergyRatingSection.vue?vue&type=style&index=0&id=06a1fad8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports